const languageFields = `language {
		code
		locale
	}`;
export default languageFields;
